import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FaqService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getFaqs(): Observable<any> { return this.http.get<any>(this.apiUrl + '/faq'); }
  addFaq(faq: any) { return this.http.post<any>(this.apiUrl + '/faq', faq); }
  updateFaq(id: number, faq: any) { return this.http.post<any>(this.apiUrl + '/faq/' + id, faq); }
  deleteFaq(id: number) { return this.http.delete<any>(this.apiUrl + '/faq/' + id); }
}
